import { createSelector } from 'reselect';
import get from 'lodash.get';
import keyBy from 'lodash.keyby';

const mergeColumns = (userColumn, defaultColumn) => {
  const nonsortable = get(defaultColumn, 'nonsortable');
  const sorted = nonsortable ? undefined : userColumn.sorted;
  return {
    ...userColumn,
    nonsortable,
    sorted,
    minWidth: get(defaultColumn, 'minWidth'),
  };
};

const mergeConfigs = (userColumns, defaultColumns) => {
  if (!userColumns || userColumns.length === 0) {
    return defaultColumns;
  }

  if (!defaultColumns || defaultColumns.length === 0) {
    return userColumns;
  }

  const defaultColumnsMap = keyBy(defaultColumns, 'id');
  return userColumns.map((uc) => mergeColumns(uc, defaultColumnsMap[uc.id]));
};

const reselected = createSelector(
  (userColumns) => userColumns,
  (_, defaultColumns) => defaultColumns,
  (userColumns, defaultColumns) => mergeConfigs(userColumns, defaultColumns),
);

class GridConfigService {
  mergeUserAndDefaultConfigs(userColumns, defaultColumns) {
    return reselected(userColumns, defaultColumns);
  }
}

export default new GridConfigService();
